<template lang="html">
  <v-flex pa-0>
    <!-- <v-hover v-slot:default="{ hover }"> -->
    <v-card>
      <!-- :elevation="hover || show ? 12 : 2"  -->
      <v-responsive :height="180">
        <v-card-text>
          <v-layout>
            <v-flex pa-0>
              <v-flex
                pb-0
                class="headline "
                style="color:rgba(0, 0, 0, 0.87)"
              >
                {{ product.name }}
              </v-flex>

              <v-flex
                xs12
                class=""
                fill-height
              >
                <div v-html="_formatLineBreaks(product.description)" />
              </v-flex>
            </v-flex>
            <v-flex
              shrink
              pl-8
              text-center
            >
              <v-img
                :src="(product.image || {}).src"
                :lazy-src="(product.image || {}).lazySrc"
                contain
                width="70"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-responsive>
      <!-- <v-expand-transition>
          <div v-show="show">
            <v-card-text class="grey lighten-4" v-html="_formatLineBreaks(product.moreInfo)"></v-card-text>
          </div>
        </v-expand-transition> -->

      <v-card-text class="text--primary">
        <span class="headline">{{ product.price > 0 ? _$(product.price) : 'FREE' }}</span>

        <!-- <v-spacer></v-spacer>
          <v-btn v-if="product.moreInfo && !hideInfo" text small @click="show = !show" color="grey">
            <v-icon v-if="show">close</v-icon>
            <span v-else>Info</span>
          </v-btn> -->
      </v-card-text>
      <v-divider />
      <v-card-actions class="">
        <v-btn
          v-if="product.moreInfo && !hideInfo"
          text
          @click="show = !show"
        >
          {{ show ? 'Less': 'More' }}
          <v-icon right>
            {{ show ? 'expand_less': 'expand_more' }}
          </v-icon>
        </v-btn>
        <v-spacer />

        <v-btn
          v-if="product.canHaveAssistance"
          text
          color="primary"
          :to="`/assistance/?calculator=${product.cid}&variant=${product.vid}`"
        >
          <v-icon left>
            face
          </v-icon>
          Assistance
        </v-btn>
        <v-btn
          text
          color="primary"
          :to="`/calculator/${product.cid}/${product.vid}`"
        >
          Get started
          <!-- <v-icon right>arrow_forward</v-icon> -->
        </v-btn>
      </v-card-actions>

      <v-expand-transition>
        <div v-show="show">
          <v-divider />

          <v-card-text v-html="_formatLineBreaks(product.moreInfo)" />
        </div>
      </v-expand-transition>
    </v-card>

    <!-- </v-hover> -->
  </v-flex>
</template>

<script>
// import { mapGetters } from 'vuex'
// import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ],
  props: {
    product: Object,
    hideInfo: Boolean
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    // ...mapGetters([]),
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>

</style>
